//
// Variables
// --------------------------------------------------

// These are ported over from creator tape so that we can use them with styled components
// https://ghe.spotify.net/tape/creator-tape/blob/master/src/styles/variables.js

// z-index master list

export const zIndexDropdown = 1000;
export const zIndexSticky = 1020;
export const zIndexFixed = 1030;
export const zIndexNavBackdrop = 1034;
export const zIndexNav = 1035;
export const zIndexDialogBackdrop = 1040;
export const zIndexDialog = 1050;
export const zIndexPopover = 1060;
export const zIndexTooltip = 1070;

// App max width
export const appMaxWidth = '1680px';

// Font weights
export const fontWeightBook = 400;
export const fontWeightBold = 700;
export const fontWeightBlack = 900;
export const fontWeightBase = fontWeightBook;
